import React, { useState } from "react";
import { IconButton, CircularProgress } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { markAsWatched } from "../../../api/services/video";
import { pushNotification } from "../../PinnacleSnackbarProvider/PinnacleSnackbarProvider";
import { NotificationTypes } from "../../PinnacleSnackbarProvider/PinnacleSnackbarProvider.types";
import { handleApiError } from "../../../utils/errorHandler";

interface MarkAsWatchedButtonProps {
    videoId: string;
    isWatched: boolean;
    onChange: (watched: boolean) => void;
}

const MarkAsWatchedButton: React.FC<MarkAsWatchedButtonProps> = ({ videoId, isWatched, onChange }) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleClick = async () => {
        if (isLoading) return;

        setIsLoading(true);
        const action = isWatched ? "remove" : "add";

        try {
            const response = await markAsWatched(videoId, action);
            if (response.result === "success") {
                onChange(action === "add" ? true : false);
            }
        } catch (err) {
            handleApiError(err, {
                notify: (msg) => {
                    pushNotification({
                        details: msg,
                        type: NotificationTypes.Error,
                    });
                },
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <IconButton
            size="small"
            onClick={handleClick}
            disabled={isLoading}
            sx={{
                color: isWatched ? "success.main" : "#fff",
                cursor: isLoading ? "not-allowed" : "pointer",
                "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                },
            }}
        >
            {isLoading ? (
                <CircularProgress size={20} sx={{ color: "#fff" }} />
            ) : isWatched ? (
                <CheckCircleIcon fontSize="small" />
            ) : (
                <CheckCircleOutlineIcon fontSize="small" />

            )}
        </IconButton>
    );
};

export default MarkAsWatchedButton;
